import React from "react"

import StoryblokImage from "../../internal/storyblokImage/StoryblokImage"
import * as styles from "./StoryCard.module.scss"


const StoryCard = ({ headline, date, label, image, thumbnail, excerpt, cta_text, cta_link }) => {
  let img;
  if(thumbnail && (thumbnail.filename !== "" && thumbnail.filename !== null)){
    img = thumbnail;
  }else if(image &&(image.filename !== "" && image.filename !== null)){
    img = image
  }else{
    img = null
  }
  let formDate = date ? new Date(date.replace(/-/g, "/")) : null;
  return (
    <article className={`panel-radius shadow-cards ${styles.wrapper}`}>
      <div className={styles.image_wrapper}>
        {<StoryblokImage sbImageData={img}/>}
        <div className={styles.link_overlay}>
          <a href={cta_link}></a>
        </div>
      </div>
      <div className={styles.content}>
        {label || date ? <div className={styles.label}>{label ? label : formDate.toLocaleDateString('en-US', {month : 'long', day: 'numeric', year: 'numeric'})}</div> : null}
        {headline ? (
          <a href={cta_link} className={styles.title}>
            <div className={styles.title}>{headline}</div>
          </a>
        ) : null}
        {excerpt ? <p>{excerpt}</p> : null}
        {cta_text ? (
          <div className={styles.cta}>
            <a href={cta_link || "#"}>{cta_text}</a>
          </div>
        ) : null}
      </div>
    </article>
  )
}

export default StoryCard